import * as React from 'react';
import { Helmet } from 'react-helmet-async';

import { useSiteMetadata } from '../utils/siteMetadata';

type SeoProps = {
  lang: string;
  title: string;
  description: string;
  game: string;
};

const Seo: React.FC<SeoProps> = ({ lang, title, description, game }) => {
  const siteMetadata = useSiteMetadata();

  const url = siteMetadata.siteUrl ?? 'https://devplay-guide.devsisters.com';
  const ogImage = `${game}-og-img-${lang}.png`;
  return (
    <>
      <Helmet>
        <html lang={lang} />
        <title>{title}</title>
        <link rel='canonical' href={url} />
        <meta name='description' content={description} />
        <meta property='og:title' content={title} />
        <meta property='og:image' content={`${url}/${ogImage}`} />
        <meta property='og:description' content={description} />
        <link rel='shortcut icon' href={`/${game}/favicon.ico`} type='image/x-icon' />
        <link rel='apple-touch-icon' sizes='57x57' href={`/${game}/apple-icon-57x57.png`} />
        <link rel='apple-touch-icon' sizes='60x60' href={`/${game}/apple-icon-60x60.png`} />
        <link rel='apple-touch-icon' sizes='72x72' href={`/${game}/apple-icon-72x72.png`} />
        <link rel='apple-touch-icon' sizes='76x76' href={`/${game}/apple-icon-76x76.png`} />
        <link rel='apple-touch-icon' sizes='114x114' href={`/${game}/apple-icon-114x114.png`} />
        <link rel='apple-touch-icon' sizes='120x120' href={`/${game}/apple-icon-120x120.png`} />
        <link rel='apple-touch-icon' sizes='144x144' href={`/${game}/apple-icon-144x144.png`} />
        <link rel='apple-touch-icon' sizes='152x152' href={`/${game}/apple-icon-152x152.png`} />
        <link rel='apple-touch-icon' sizes='180x180' href={`/${game}/apple-icon-180x180.png`} />
        <link rel='icon' type='image/png' sizes='192x192' href={`/${game}/android-icon-192x192.png`} />
        <link rel='icon' type='image/png' sizes='32x32' href={`/${game}/favicon-32x32.png`} />
        <link rel='icon' type='image/png' sizes='96x96' href={`/${game}/favicon-96x96.png`} />
        <link rel='icon' type='image/png' sizes='16x16' href={`/${game}/favicon-16x16.png`} />
        <meta name='msapplication-TileImage' content={`/${game}/ms-icon-144x144.png`} />
      </Helmet>
    </>
  );
};

export default React.memo(Seo);
